import License from "../../../formability/licenseBuilder/models/license";
import FieldPresenceValidator from "../navigableValidators/fieldPresenceValidator";
import NavigableValidation from "./navigableValidation";
import UrlValidator from "../navigableValidators/urlValidator";
import SlugValidator from "../navigableValidators/slugValidator";
import EmbeddedCollectionValidator from "../navigableValidators/embeddedCollectionValidator";
import MinMaxFieldValidator from "../navigableValidators/minMaxFieldValidator";
import {minMaxType} from "~/enums/minMaxValidatorType";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import {Route} from "~/enums/route";

export default class LicenseBuilderValidation extends NavigableValidation<License> {
  baseRoute = Route.editLicense

  validators = [
    new UrlValidator({
      validatorKey: 'application_url',
      section: ValidationModalSection.PublicProfile
    }),
    new UrlValidator({
      validatorKey: 'pdf_url',
      section: ValidationModalSection.PublicProfile
    }),
    new EmbeddedCollectionValidator({
      validatorKey: 'resources',
      section: ValidationModalSection.PublicProfile
    }, this.model),
    new SlugValidator({
      validatorKey: 'seo_url',
      anchorHash: 'slug',
      section: ValidationModalSection.PublicProfile
    }),
    new MinMaxFieldValidator({
      validatorKey: 'min_completion_time',
      section: ValidationModalSection.PublicProfile,
      min_field: 'min_completion_time',
      max_field: 'max_completion_time',
      minMaxType: minMaxType.duration,
      min_field_unit: 'min_completion_time_unit',
      max_field_unit: 'max_completion_time_unit'
    }),
    new MinMaxFieldValidator({
      validatorKey: 'min_approval_time',
      section: ValidationModalSection.PublicProfile,
      min_field: 'min_approval_time',
      max_field: 'max_approval_time',
      minMaxType: minMaxType.duration,
      min_field_unit: 'min_approval_time_unit',
      max_field_unit: 'max_approval_time_unit'
    }),
    new MinMaxFieldValidator({
      validatorKey: 'min_cost',
      section: ValidationModalSection.PublicProfile,
      min_field: 'min_cost',
      max_field: 'max_cost',
      minMaxType: minMaxType.currency,
      conditional_field: 'cost_type'
    }),
    ...this.publicProfileFieldPresenceValidators,
    ...this.definitionFieldPresenceValidators
  ];

  get publicProfileFieldPresenceFields(): Array<string> {
    return [
      'description',
      'apply_section_header',
      'apply_sub_text',
      'apply_button_label',
    ];
  }

  get publicProfileFieldPresenceValidators(): Array<FieldPresenceValidator<License>> {
    return this.publicProfileFieldPresenceFields.map(field => new FieldPresenceValidator({
      validatorKey: field,
      section: ValidationModalSection.PublicProfile
    }))
  }

  get definitionFieldPresenceFields(): Array<string> {
    return [
      'title',
      'application_type',
    ]
  }

  get definitionFieldPresenceValidators(): Array<FieldPresenceValidator<License>> {
    return this.definitionFieldPresenceFields.map(field => new FieldPresenceValidator({
      validatorKey: field,
      section: ValidationModalSection.Definition
    }))
  }

}